import React, { useEffect, useState } from 'react';
import { Divider } from '@material-ui/core';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import useStyles from '../styles.js';
import CustomStyledButton from '../../../SharedComponents/CustomButton/CustomButton.jsx';
import limitedOfferImg from "../../../assets/images/LimitedOffer.svg"
import crown from "../../../assets/images/buttonCrown.svg";
import icon1 from "../../../assets/images/blueFire.svg";
import icon2 from "../../../assets/images/chart.svg";
import icon3 from "../../../assets/images/share.svg";
import icon4 from "../../../assets/images/keyBook.svg";
import sandboxLogo from "../../../assets/images/sanboxLogoblack.svg";
import crownlogo from "../../../assets/images/crown.svg";
import { CircularProgress } from '@mui/material';
import Cookies from "js-cookie";
import swal from 'sweetalert';
import { getUserSubscriptionData } from '../../../Core/utils/auth.js';
import { API } from '../../../Services/api-service.js';
import { getIPInfo } from '../../../lib/IpInfo.js';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import { clearAuthCookies } from '../../../Core/utils/cookieUtils.js';
import useAuthEventLog from '../../../hooks/useAuthEventLog';
import { clearLocalStorageKeepingHomepageChoice } from "../../../utils/homepageVersion";
const BuyPremiumPopup = ({ isOpen, onClose, handleUpgradeClick, loading, type = 1, }) => {
    const { logAuthEventBeforeLeaving, AUTH_EVENTS } = useAuthEventLog();
    const [loader, setLoader] = useState(false);
    const [data, setData] = useState([]);
    const countryMapping = {
        "united states": "usa",
        "united kingdom": "uk",
        "great britain": "uk",
    };
    const fetchData = async () => {
        setLoader(true);
        try {
            const ipInfo = await getIPInfo();
            let country = ipInfo.country?.toLowerCase();
            if (countryMapping[country]) {
                country = countryMapping[country];
            }
            const response = await API.get("/subscription/plans");
            setData(response?.data?.plans[country] || response?.data?.plans["usa"]);
            setLoader(false);
        }
        catch (err) {
            setLoader(false);
            console.error("Error fetching subscription plans:", err);
        }
    };
    useEffect(() => {
        if (isOpen) {
            fetchData();
        }
    }, [isOpen]);
    const classes = useStyles();
    const userData = getUserSubscriptionData();
    const calculateDaysLeft = (expiry) => {
        if (!expiry) return 0;
        const currentDate = new Date();
        const targetDate = new Date(expiry);
        const timeDiff = targetDate - currentDate;
        const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
        return daysLeft > 0 ? daysLeft : 0;
    }
    if (!isOpen) return null;
    const getCurrencySymbol = (currency) => {
        if (currency === "USD") return "$";
        if (currency === "EUR") return "€";
        if (currency === "INR") return "₹";
        if (currency === "GBP") return "£";
        if (currency === "JPY") return "¥";
        return "$";
    };


    const benefits = [
        {
            text: "10,000+ learning activities and exercises for every school grade",
            icon: icon1
        },
        {
            text: "Full access to all the learning paths and subjects which you can learn at your own pace",
            icon: icon2
        },
        {
            text: "Evaluations which can be used to test your topic mastery and get insights",
            icon: icon3
        },
        {
            text: "Full access to all new features which keep getting added - including language learning, general trivia, puzzles and games",
            icon: icon4
        }
    ];
    const matchesSm = window.innerWidth <= 600;
    const logout = () => {
        swal({
            title: "Logout",
            text: "Do you really want to logout?",
            buttons: ["No", "Yes, Logout"],
            closeOnClickOutside: false,
            closeOnEsc: false,
        }).then((logout) => {
            if (logout) {
                // Built before the session is cleared below; sent with keepalive, so the redirect doesn't wait.
                logAuthEventBeforeLeaving(AUTH_EVENTS.LOGOUT, {
                    source: "premium-popup",
                });
                Cookies.remove("AuthorizationToken", { domain: ".codeyoung.com" });
                Cookies.remove("homeWorkCatalogId", { domain: ".codeyoung.com" });
                Cookies.remove("homeWorkViewAll", { domain: ".codeyoung.com" });
                Cookies.remove("homeWorkExerciseId", { domain: ".codeyoung.com" });
                Cookies.remove("userName", { domain: ".codeyoung.com" });
                Cookies.remove("userId", { domain: ".codeyoung.com" });
                Cookies.remove("grade", { domain: ".codeyoung.com" });
                Cookies.remove("tracker", { domain: ".codeyoung.com" });
                clearAuthCookies();
                clearLocalStorageKeepingHomepageChoice();
                if (localStorage.getItem("darkMode")) {
                    localStorage.removeItem("darkMode");
                }
                window.location.replace("/");
            }
        });
    };


    return (
        <div className={type === 1 ? classes.popupOverlay : classes.blockingOverlay} onClick={type === 1 ? onClose : undefined}>

            {loader ? <div className={classes.popupContainer} style={{ height: "100px" }}><CircularProgress /></div>
                :
                <div className={classes.popupContainer} onClick={(e) => e.stopPropagation()}>
                    {type === 1 ? <button className={classes.closeButton} onClick={onClose}>
                        ×
                    </button> : <button className={classes.logoutButton} onClick={logout}>Logout <PowerSettingsNewIcon style={{ width: "18px", height: "18px", marginLeft: "2px", marginTop: "-4px" }} /></button>}

                    <div className={classes.popupHeader}>
                        <div >{type === 1 ? <img className={classes.popupLogo} src={limitedOfferImg} alt="Limited Offer" /> : <img className={classes.popupLogo} src={sandboxLogo} alt="Sandbox" />}</div>
                    </div>

                    {type === 2 && <p className={classes.popupSubtitle}>Your learning progress is safe with us</p>}
                    {type === 2 && <p className={classes.popupSubtitle2}> <img src={crownlogo} alt=" crown" />Upgrade today to continue learning</p>}
                    <div className={classes.pricingInfo}>
                        <p className={classes.pricingText}> <span className={classes.slashedPriceText}>{`${getCurrencySymbol(data?.currency)}${data?.actualPrice}/month`}</span> {matchesSm && <br />}{` ${getCurrencySymbol(data?.currency)}${data?.sellingPrice} for Lifetime access to Sandbox`}</p>
                    </div>
                    <Divider style={{ margin: "8px 0 16px 0" }} />

                    <div className={classes.benefitsContainer}>
                        <h3 className={classes.benefitsTitle}>What you will get?</h3>
                        {benefits.map((benefit, index) => (
                            <div key={index} className={classes.benefitItem}>
                                <span className={classes.benefitIcon}>
                                    <img src={benefit.icon} alt="Benefit Icon" />
                                </span>
                                <span>{benefit.text}</span>
                            </div>
                        ))}
                    </div>
                    <div className={classes.upgradeButtonContainer}>
                        <CustomStyledButton
                            style={{ padding: loading ? "6px 12px" : "" }}
                            onClick={handleUpgradeClick}
                            disabled={loading}
                            type="yellow"
                            endIcon={loading ? null : <img src={crown} alt="Crown Icon" style={{ marginBottom: "6px", marginTop: "-4px" }} />}
                        >
                            {loading ? <CircularProgress size="20px" sx={{ color: "#ff5722", padding: "0px" }} /> : (type === 1 ? `Buy now for ${getCurrencySymbol(data?.currency)}${data?.sellingPrice}` : `Upgrade now for ${getCurrencySymbol(data?.currency)}${data?.sellingPrice}`)}
                        </CustomStyledButton>
                    </div>


                    <p className={classes.freeTrialText} style={{ color: type === 1 ? (calculateDaysLeft(userData?.expiresAt) > 14 ? "#808080" : "#DA4A54") : "#DA4A54", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {type === 1 ?

                            calculateDaysLeft(userData?.expiresAt) > 14 ? (
                                <>
                                    15 days free access activated
                                </>
                            ) : (
                                <>
                                    <ErrorOutlineIcon style={{ marginRight: '4px', color: '#DA4A54', height: "14px", width: "14px" }} fontSize="small" />
                                    Your free trial ends in <span style={{ fontWeight: 700, marginLeft: "4px" }}>{calculateDaysLeft(userData?.expiresAt)} days</span>
                                </>
                            ) :
                            (<>
                                <ErrorOutlineIcon style={{ marginRight: '4px', color: '#DA4A54', height: "14px", width: "14px" }} fontSize="small" />
                                The free trial period is over
                            </>)
                        }
                    </p>
                </div>
            }

        </div>
    );
};

export default BuyPremiumPopup;